import type { ReactNode } from 'react';
import { useGetToPath, useResourceParams, useTranslate } from '@refinedev/core';
import type { BaseKey } from '@refinedev/core';
import { Link } from 'react-router-dom';
import { Space } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

export type ShowIconLinkProps = {
  resource: string;
  id: BaseKey;
  children?: ReactNode;
};

/** Dependent-resource display: plain (non-clickable) text with a separate
 * `LinkOutlined` icon linking to the resource's show page. */
export const ShowIconLink = ({ resource, id, children }: ShowIconLinkProps) => {
  const t = useTranslate();
  const getToPath = useGetToPath();
  const { resource: resourceItem } = useResourceParams({ resource });
  const to = getToPath({
    resource: resourceItem,
    action: 'show',
    meta: { id },
  });
  const content = children ?? id;
  if (!to) return <>{content}</>;
  return (
    <Space size={4}>
      {content}
      <Link
        to={to}
        aria-label={t('actions.show')}
        onClick={(e) => e.stopPropagation()}
      >
        <LinkOutlined />
      </Link>
    </Space>
  );
};
